<template
    ><div class="genrepie">
        <apexchart type="pie" :options="options" :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: "GenreWidget",
    props: ["genres"],
    computed: {
        series() {
            return Object.values(this.genres);
        },
        options() {
            return {
                chart: {
                    type: "pie"
                },
                labels: Object.keys(this.genres),
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }
                ]
            };
        }
    }
};
</script>

<style scoped>
::v-deep .apexcharts-legend-text {
    color: white !important;
}

.genrepie {
    max-width: 800px;
    margin: auto;
}
</style>
